//axios api
import api from "@/lib/Api";

export const getAllTargetList = async () => {
  try {
    const queryRoute = `/targetSales/getAllTargetList`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAllShopTargetList = async (date) => {
  try {
    const queryRoute = `/targetSales/getAllShopTargetList/${date}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createOrUpdateTargetSales = async (data, mode) => {
  try {
    const queryRoute = `/targetSales/createOrUpdateTargetSales`;

    const reqBody = {
      data: data,
      mode: mode,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getShopSalesTagetTotal = async (
  workLocationId,
  targetDatetime
) => {
  try {
    const queryRoute = `/targetSales/getShopSalesTagetTotal`;

    const reqBody = {
      targetDatetime: targetDatetime,
      workLocationId: workLocationId,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAllShopSalesTagetTotal = async (targetDatetime) => {
  try {
    const queryRoute = `/targetSales/getAllShopSalesTagetTotal`;

    const reqBody = {
      targetDatetime: targetDatetime,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updatedSalesMonthlyTarget = async (updatedRows) => {
  try {
    const queryRoute = `/targetSales/updateSalesMonthlyTarget`;

    const reqBody = {
      updatedRows,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const importMonthlyTarget = async (datetime, data) => {
  try {
    const queryRoute = `/targetSales/importMonthlyTarget`;

    const reqBody = {
      datetime: datetime,
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getMonthlyTargetWorkLocation = async (datetime, data) => {
  try {
    const queryRoute = `/targetSales/getMonthlyTargetWorkLocation`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
